import { defineComponent, mergeModels, useModel, useAttrs, computed, createElementBlock, openBlock, normalizeStyle, normalizeClass, renderSlot, createVNode, withDirectives, unref, createCommentVNode, toDisplayString, mergeProps, createElementVNode, vShow } from "vue";
import { useInputClasses } from "../useInputClasses.js";
import VueDatePicker from "@vuepic/vue-datepicker";
const _hoisted_1 = ["data-has-error"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{
    name: "PInlineDatePicker",
    inheritAttrs: false
  },
  __name: "p-inline-date-picker",
  props: /* @__PURE__ */ mergeModels({
    label: { default: "" },
    errorMsg: { default: "" },
    required: { type: Boolean, default: false },
    uid: {},
    name: {},
    is24: { type: Boolean },
    enableTimePicker: { type: Boolean, default: false },
    range: { type: [Boolean, Object] },
    multiCalendars: { type: [Boolean, Number, String, Object] },
    modelValue: {},
    locale: {},
    position: {},
    dark: { type: Boolean },
    placeholder: {},
    weekNumbers: {},
    hoursIncrement: {},
    hoursGridIncrement: {},
    secondsGridIncrement: {},
    minutesGridIncrement: {},
    minutesIncrement: {},
    secondsIncrement: {},
    minDate: {},
    maxDate: {},
    minTime: {},
    maxTime: {},
    weekStart: { default: 0 },
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    format: {},
    previewFormat: {},
    hideInputIcon: { type: Boolean },
    state: { type: Boolean },
    clearable: { type: Boolean },
    alwaysClearable: { type: Boolean },
    autoApply: { type: Boolean, default: true },
    filters: {},
    disableMonthYearSelect: { type: Boolean },
    yearRange: {},
    disabledDates: {},
    inline: { type: [Boolean, Object], default: true },
    selectText: {},
    cancelText: {},
    weekNumName: {},
    autoPosition: { type: [Boolean, String] },
    monthPicker: { type: Boolean },
    timePicker: { type: Boolean },
    textInput: { type: [Boolean, Object] },
    monthNameFormat: {},
    startDate: {},
    startTime: {},
    hideOffsetDates: { type: Boolean, default: true },
    noToday: { type: Boolean },
    noHoursOverlay: { type: Boolean },
    noMinutesOverlay: { type: Boolean },
    noSecondsOverlay: { type: Boolean },
    altPosition: {},
    disabledWeekDays: {},
    allowedDates: {},
    nowButtonLabel: {},
    monthChangeOnScroll: { type: [Boolean, String] },
    markers: {},
    transitions: { type: [Boolean, Object] },
    enableSeconds: { type: Boolean },
    escClose: { type: Boolean },
    spaceConfirm: { type: Boolean },
    monthChangeOnArrows: { type: Boolean },
    formatLocale: {},
    autocomplete: {},
    multiDates: { type: [Boolean, Object] },
    presetDates: {},
    flow: {},
    partialFlow: { type: Boolean },
    preventMinMaxNavigation: { type: Boolean },
    utc: { type: [Boolean, String] },
    reverseYears: { type: Boolean },
    weekPicker: { type: Boolean },
    vertical: { type: Boolean },
    ariaLabels: {},
    arrowNavigation: { type: Boolean },
    yearPicker: { type: Boolean },
    dayNames: {},
    modelType: { default: "yyyy-MM-dd" },
    modelAuto: { type: Boolean },
    highlight: {},
    offset: {},
    teleportCenter: { type: Boolean },
    teleport: { type: [Boolean, String] },
    ignoreTimeValidation: { type: Boolean },
    dayClass: {},
    hideNavigation: {},
    sixWeeks: { type: [Boolean, String] },
    timezone: {},
    disableYearSelect: { type: Boolean },
    focusStartDate: { type: Boolean },
    disabledTimes: {},
    timePickerInline: { type: Boolean },
    calendar: {},
    config: {},
    quarterPicker: { type: Boolean },
    yearFirst: { type: Boolean },
    loading: { type: Boolean },
    onInternalModelChange: {},
    enableMinutes: { type: Boolean },
    ui: {}
  }, {
    "modelValue": { default: "" },
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props) {
    const props = __props;
    const model = useModel(__props, "modelValue");
    const attrs = useAttrs();
    const { labelClasses, errorMsgClasses } = useInputClasses(props);
    const datePickerProps = computed(() => {
      const { modelValue: _, ...propsWithoutModelValue } = props;
      const { class: classes, style: style2, ...attrsWithoutClassAndStyle } = attrs;
      return { ...propsWithoutModelValue, ...attrsWithoutClassAndStyle };
    });
    const style = computed(() => {
      return attrs.style;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass([{ hidden: _ctx.$attrs.hidden }, _ctx.$attrs.class]),
        "data-has-error": !!_ctx.errorMsg,
        style: normalizeStyle(style.value)
      }, [
        renderSlot(_ctx.$slots, "label", {
          label: _ctx.label,
          labelClasses: unref(labelClasses)
        }, () => [
          _ctx.label ? (openBlock(), createElementBlock("label", {
            key: 0,
            class: normalizeClass(unref(labelClasses))
          }, toDisplayString(_ctx.label), 3)) : createCommentVNode("", true)
        ]),
        createVNode(unref(VueDatePicker), mergeProps({
          modelValue: model.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => model.value = $event)
        }, datePickerProps.value), null, 16, ["modelValue"]),
        withDirectives(createElementVNode("div", {
          class: normalizeClass(unref(errorMsgClasses))
        }, toDisplayString(_ctx.errorMsg), 3), [
          [vShow, _ctx.errorMsg]
        ])
      ], 14, _hoisted_1);
    };
  }
});
export {
  _sfc_main as _
};
